export default function (timeout = 100) {
    return new Promise(resolve => { // eslint-disable-line compat/compat
        let timer;

        function onScroll() {
            clearTimeout(timer);

            timer = setTimeout(() => {
                window.removeEventListener('scroll', onScroll);
                resolve();
            }, timeout);
        }

        window.addEventListener('scroll', onScroll);

        // In case no scrolling happens at all
        onScroll();
    });
}
